var _defs, _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureDataFactory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a14",
    x1: 0.5,
    y1: 9.77,
    x2: 9,
    y2: 9.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0060a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0071c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0074cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#006abb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#005ba1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 10.48V6.57a.14.14 0 00-.24-.1l-4 4-4.16 4.16v2.87h12.08a.56.56 0 00.57-.57V6.57a.14.14 0 00-.24-.1z",
    fill: "#005ba1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 3.58C2.4 3.58.5 2.89.5 2v14.93a.56.56 0 00.57.57H9V2c0 .89-1.9 1.58-4.25 1.58z",
    fill: "url(#a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 12.97,
    width: 2.27,
    height: 2.27,
    rx: 0.28,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.97,
    y: 12.97,
    width: 2.27,
    height: 2.27,
    rx: 0.28,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.03,
    y: 12.97,
    width: 2.27,
    height: 2.27,
    rx: 0.28,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2c0 .85-1.9 1.54-4.25 1.54S.5 2.89.5 2 2.4.5 4.75.5 9 1.19 9 2",
    fill: "#eaeaea"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.91c0 .55-1.46 1-3.26 1s-3.26-.43-3.26-1S3 .94 4.75.94 8 1.37 8 1.91",
    fill: "#50e6ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 2.14a8.07 8.07 0 00-2.58.37 7.64 7.64 0 002.58.38 7.64 7.64 0 002.58-.38 8.07 8.07 0 00-2.58-.37z",
    fill: "#198ab3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureDataFactory);
export default __webpack_public_path__ + "static/media/azure-dataFactory.52706bf5be4cd37f50ae9a8f1ffb26dd.svg";
export { ForwardRef as ReactComponent };